import React, { FC } from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import CheckIcon from '../../../../assets/icons/CheckIcon';
import { colorsPalette } from '../../../../theme';
import { KeyLearningObjective } from '../../../../types';
import { useHtmlBlockStyles, useTextStyles } from '../../../../utils/styles';
import useStyles from './styles';

interface LearnInfoBlockProps {
  learnItems?: (KeyLearningObjective | null)[] | null;
  whatIsItForContent?: string | null;
  requirementsContent?: string | null;
}

const LearnInfoBlock: FC<LearnInfoBlockProps> = ({
  learnItems,
  whatIsItForContent,
  requirementsContent,
}) => {
  const classes = useStyles();
  const textClasses = useTextStyles();
  const htmlBlockStyles = useHtmlBlockStyles();

  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <Container>
        <Typography variant="h2" className={cx(classes.title, textClasses.h2)}>
          {t('page.course.whatYouWillLearn')}
        </Typography>
        {Boolean(learnItems?.length) && (
          <Grid container className={classes.learnItemsWrapper}>
            {learnItems &&
              learnItems.map((item) => (
                <Grid key={item?.id} item md={4} sm={6} xs={12} className={classes.learnItem}>
                  <CheckIcon className={classes.learnItemIcon} color={colorsPalette.primary} />
                  <Typography className={cx(classes.learnItemTitle, textClasses.bodyText)}>
                    {item?.title}
                  </Typography>
                </Grid>
              ))}
          </Grid>
        )}
        {whatIsItForContent && (
          <>
            <Typography variant="h2" className={cx(classes.title, textClasses.h2)}>
              {t('page.course.whatIsThisFor')}
            </Typography>
            <Typography className={cx(classes.textBlock, textClasses.bodyText)}>
              {whatIsItForContent}
            </Typography>
          </>
        )}
        {requirementsContent && (
          <>
            <Typography variant="h2" className={cx(classes.title, textClasses.h2)}>
              {t('page.course.requirements')}
            </Typography>
            <div
              className={cx(classes.textBlock, htmlBlockStyles.wrapper, 'wrapperWithStyledTable')}
            >
              {parser(requirementsContent)}
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default LearnInfoBlock;
